// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicSuburbanV1SaveUserEstimationScoreFactRequest,
  TPublicSuburbanV1SaveUserEstimationScoreFactModel,
  IMappers,
  TPublicSuburbanV1SaveUserEstimationScoreFactResponse,
  IPublicSuburbanV1SaveUserEstimationScoreFactResponseError,
} from './types';

export const defaultConfig: TPublicSuburbanV1SaveUserEstimationScoreFactModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/suburban/v1/save-user-estimation-score-fact/',
  requestType: 'json',
} as TPublicSuburbanV1SaveUserEstimationScoreFactModel;

export function createPublicSuburbanV1SaveUserEstimationScoreFactModel(
  parameters: IPublicSuburbanV1SaveUserEstimationScoreFactRequest,
): TPublicSuburbanV1SaveUserEstimationScoreFactModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicSuburbanV1SaveUserEstimationScoreFactOptions<TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400>;
  parameters: IPublicSuburbanV1SaveUserEstimationScoreFactRequest;
}

export async function fetchPublicSuburbanV1SaveUserEstimationScoreFact<TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1SaveUserEstimationScoreFactOptions<TResponse400>): Promise<
  TPublicSuburbanV1SaveUserEstimationScoreFactResponse | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicSuburbanV1SaveUserEstimationScoreFactModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IPublicSuburbanV1SaveUserEstimationScoreFactResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicSuburbanV1SaveUserEstimationScoreFactResponse;
}
